import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-white py-14 sm:py-20" aria-labelledby="pain-heading" data-id="element-266" data-mp="tlab3tn5dtgf">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-267" data-mp="yjlky4dg03yn">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-268" data-mp="yk3q5qi31sip">
          From clinical uncertainty to confident planning
        </p>
        <h2 id="pain-heading" className="mt-3 max-w-3xl font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-269" data-mp="1r8sjv4gt6vkf">
          You don’t need more random information.
        </h2>
        <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-ink-700 sm:text-lg" data-id="element-270" data-mp="1hgms9vugyg5r">
          You need a system that helps you know what to look at, what questions to ask, and
          what decisions to make <strong className="font-bold text-navy-900" data-id="element-271" data-mp="2a13e69xedl6x">before</strong>{' '}
          approving a treatment plan. The Aligner Planning Master System™ brings clinical
          protocols, visual decision tools, checklists, and case-based examples into one
          structured library.
        </p>

        <div className="mt-10 rounded-2xl bg-navy-950 p-5 sm:p-8" data-id="element-272" data-mp="awgs0bm1dqod">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-300" data-id="element-273" data-mp="62ubg8cr52na">
            Before the system
          </p>
          <h3 className="mt-2 font-display text-xl font-extrabold text-white sm:text-2xl" data-id="element-274" data-mp="kumnobh920ks">
            Does this sound familiar?
          </h3>

          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-275" data-mp="tthzc332c2vh">
            {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.04] p-3.5" data-id="element-276" data-mp="prd2ywl8cs55">
                <AlertCircleIcon aria-hidden="true" className="mt-0.5 h-[18px] w-[18px] shrink-0 text-orange-400" data-id="element-277" data-mp="2rizs0slkacyz" />
                <span className="text-[13.5px] leading-snug text-brand-100" data-id="element-278" data-mp="uk6o1inljzbb">{point}</span>
              </li>)}
          </ul>

          <p className="mt-6 text-[15px] font-semibold text-white" data-id="element-279" data-mp="14gt3tt12g06h">
            If you’ve experienced even one of these situations, the Aligner Planning Master
            System™ was created for you.
          </p>
        </div>

        <SectionCta label="I want a clear planning system" data-id="element-280" data-mp="1dg6id041rey2" />
      </div>
    </section>;
}